import api from "@/services/api";

export const checkForDelimiters = (val) => {
  if (typeof val === "string" && /(\||,)/.test(val)) {
    return splitMulti(val, [',', '|']);
  }
  
  return val;
};

export const getResource = async (name, importId) => {
  const clubId = api.clientData("user_club_id");
  const response = await api.get(
    `api/v1/club-import/${clubId}/${importId}/${name}`
  );
  return response;
};

export const postResource = async (name, importId, formData) => {
  const clubId = api.clientData("user_club_id");
  const response = await api.postFormData(
    `api/v1/club-import/${clubId}/${importId}/${name}`,
    formData
  );
  return response;
};

export const postJsonResource = async (name, importId, data) => {
  const clubId = api.clientData("user_club_id");
  const response = await api.post(
    `api/v1/club-import/${clubId}/${importId}/${name}`,
    data
  );
  return response;
};

export const updateResource = async (name, importId, data) => {
  const clubId = api.clientData("user_club_id");
  const response = await api.putJsonData(
    `api/v1/club-import/${clubId}/${importId}/${name}`,
    { data: data }
  );
  return response;
};

export const deleteResource = async (name, importId, data) => {
  const clubId = api.clientData("user_club_id");
  const response = await api.delete(
    `api/v1/club-import/${clubId}/${importId}/${name}`,
    data
  );
  return response;
};

export const splitMulti = (str, tokens) => {
    let tempChar = tokens[0];
    
    for (let i = 1; i < tokens.length; i++){
        str = str.split(tokens[i]).join(tempChar);
    }
    
    return str.split(tempChar).map(s => s.trim());
};
